import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

enum PlanTypeEnum {
  HEALTH = 'Health',
  DENTAL = 'Dental',
  HEALTH_DENTAL = 'HealthAndDental',
}

type PlanType = Record<PlanTypeEnum, string>;

const PLAN_TYPE_NAME: PlanType = {
  [PlanTypeEnum.HEALTH]: 'Saúde',
  [PlanTypeEnum.DENTAL]: 'Odonto Puro',
  [PlanTypeEnum.HEALTH_DENTAL]: 'Saúde + Odonto',
};

const PLAN_TYPE_COLOR: PlanType = {
  [PlanTypeEnum.HEALTH]: NEW_COLORS.PRIMARY[500],
  [PlanTypeEnum.DENTAL]: NEW_COLORS.SECONDARY[500],
  [PlanTypeEnum.HEALTH_DENTAL]: NEW_COLORS.SEMANTICS.INFO[900],
};

export { PLAN_TYPE_COLOR, PLAN_TYPE_NAME, PlanTypeEnum };
